import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SidenavService {
  // Signal to track sidenav open/close state
  private _opened = signal(false);

  // Expose readonly signal
  readonly opened = this._opened.asReadonly();

  toggle(): void {
    this._opened.update((value) => !value);
  }

  open(): void {
    this._opened.set(true);
  }

  close(): void {
    this._opened.set(false);
  }
}
